<script>
	import { api } from "../api";
	import * as L from "leaflet";
	import { onMount, onDestroy } from "svelte";
	import GRS from "../components/GRS.svelte";
	import { addOverlay, globalOverlay, removeOverlay, getMap } from "../map";

	const devices = api.devices.store;
	let layer;
	onMount(() => {
		layer = L.layerGroup();
		addOverlay("GRS", layer, globalOverlay);
		layer.addTo(getMap());
	});
	onDestroy(() => {
		removeOverlay(layer, globalOverlay);
		layer.removeFrom(getMap());
	});
</script>

{#await api.devices.get() then _}
	{#each Object.values($devices) as device (device.id)}
		{#if device.type === "GRS" && device.latitude && device.longitude && device.state !== "DISCONNECTED"}
			<GRS {device} {layer} />
		{/if}
	{/each}
{/await}
